import { FaBalanceScale, FaUsers, FaChartLine, FaShieldAlt, FaHandshake, FaSearch } from 'react-icons/fa';

export const bufetesBenefits = [
    { icon: <FaUsers />, title: "Amplía tu clientela", description: "Accede a una amplia base de clientes potenciales en busca de servicios legales." },
    { icon: <FaChartLine />, title: "Aumenta tu visibilidad", description: "Destaca tu experiencia y especialidades en nuestra plataforma de alto tráfico." },
    { icon: <FaShieldAlt />, title: "Gestión eficiente", description: "Utiliza nuestras herramientas para administrar casos y comunicaciones de manera efectiva." }
  ];


export const usuariosBenefits = [
    { icon: <FaSearch />, title: "Encuentra el abogado ideal", description: "Accede a una amplia red de profesionales legales calificados para tu caso específico." },
    { icon: <FaHandshake />, title: "Conexiones confiables", description: "Conecta con abogados verificados y lee reseñas de otros usuarios." },
    { icon: <FaBalanceScale />, title: "Soluciones a medida", description: "Obtén asesoramiento legal personalizado para tus necesidades únicas." }
  ];